import { API_GET, API_POST, API_PUT } from "../api.service"
import { cacheUtil } from "../../services/Common";

const API_URL = "lead-scoring";


export const getLeadScoringConfigs = async () => {
    try {
        debugger;
        const response = await API_GET(`${API_URL}`);
        return response;
    } catch (error) {
        console.error("Error fetching lead scoring configs", error);
        throw error;
    }
};

export const createLeadScoringConfig = async (data) => {
    try {
        const response = await API_POST(API_URL, data);
        return response.data;
    } catch (error) {
        console.error("Error creating lead scoring config", error);
        throw error;
    }
};

export const updateLeadScoringConfig = async (id, data) => {
    try {
        const response = await API_PUT(`${API_URL}/${id}`, data);
        return response.data;
    } catch (error) {
        console.error("Error updating lead scoring config", error);
        throw error;
    }
};

export const executeLeadScoring = async (id, data) => {
    try {
        const response = await API_POST(`${API_URL}/execute/${id}`, data);
        return response.data;
    } catch (error) {
        console.error("Error executing lead scoring", error);
        throw error;
    }
};

export const getProspectfields = (user) => {
    return new Promise(async (resolve, reject) => {
        debugger;
        let registerRequest;
        try {
            if (user && user.admin) {
                let prospect_fields = cacheUtil.get("prospect_fields");
                if (prospect_fields !== null) {
                    registerRequest = prospect_fields;
                    resolve(registerRequest);
                }
                else {
                    registerRequest = await API_POST("action/getdata", {
                        root: "prospect_fields",
                        con: { admin: user && user.admin },
                        cols: {},
                    });
                    cacheUtil.set("prospect_fields", registerRequest.data);
                    resolve(registerRequest.data);
                }
            }
            else {
                resolve([]);
            }
        } catch (error) {
            console.error("Error fetching prospect fields", error);
            reject(error);
        }
    });
};